import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
class AccessPage extends React.Component<any> {
  constructor(props: any) {
    super(props);
    this.goBack = this.goBack.bind(this);
  }
  componentDidMount() {}
  goBack() {
    this.props.history.goBack();
  }
  render() {
    return (
      <section>
        <h1 className="page-title">Positioning Module Session update</h1>
        <section className="card">
          <br />
          <br />

          <button onClick={this.goBack} className="btn btn-primary">
            Go Back to Positioning Module
          </button>
        </section>
      </section>
    );
  }
}

export default withRouter(AccessPage);
